__turbopack_context__.v({
  "activities": "SOWCAG_activities",
  "activitiesHeader": "SOWCAG_activitiesHeader",
  "activityCategory": "SOWCAG_activityCategory",
  "activityPoints": "SOWCAG_activityPoints",
  "activityRow": "SOWCAG_activityRow",
  "activityTitle": "SOWCAG_activityTitle",
  "body": "SOWCAG_body",
  "callout": "SOWCAG_callout",
  "calloutIcon": "SOWCAG_calloutIcon",
  "calloutText": "SOWCAG_calloutText",
  "card": "SOWCAG_card",
  "closeBtn": "SOWCAG_closeBtn",
  "ctaBtn": "SOWCAG_ctaBtn",
  "eyebrow": "SOWCAG_eyebrow",
  "header": "SOWCAG_header",
  "modalContainer": "SOWCAG_modalContainer",
  "points": "SOWCAG_points",
  "stat": "SOWCAG_stat",
  "statLabel": "SOWCAG_statLabel",
  "statValue": "SOWCAG_statValue",
  "stats": "SOWCAG_stats",
  "summary": "SOWCAG_summary",
  "title": "SOWCAG_title",
  "topAlignedOverlay": "SOWCAG_topAlignedOverlay",
  "totalLabel": "SOWCAG_totalLabel",
  "totalRow": "SOWCAG_totalRow",
  "totalValue": "SOWCAG_totalValue",
});
